module.exports = "https://cdn2-fs.clearscore.com/flux/images/c249de866a2003a7172380e0c0c51ca8.jpg";